import * as Config from '../../../config';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AriaModal from 'react-aria-modal';
import './Modal.css';

import IconClose from '../svg/IconClose'

import { connect } from "react-redux";
import { setModal } from "../../../actions/index";
import { setStateShortcuts } from "../shortcut/redux/actions/index";

function ConnectedModal({
  title = null, description = null, content = null, active = false, enableHeader = false, underlayClickExits = true, height, style,
  underlayBackground = `rgba(57,57,57,0.8)`,
  setModal, setStateShortcuts
}) {
  const [modalHasEntered, setModalHasEntered] = useState(false);

  const deactivateModal = () => {
    setModalHasEntered(false);
    setTimeout(() => {
      setModal({ title: null, description: null, content: null, active: false });
      setStateShortcuts(true);
    }, 300);
  };
  const onModalEnter = () => setModalHasEntered(true);

  return (
    <AriaModal
      titleText="ModalBP"
      onEnter={onModalEnter}
      onExit={deactivateModal}
      focusDialog={true}
      focusTrapOptions={{active: false}}
      mounted={active}
      verticallyCenter={true}
      underlayClickExits={underlayClickExits}
      escapeExits={underlayClickExits}
      underlayClass={`underlay ${modalHasEntered && `has-entered`} ${Config.API_NAME} `}
      underlayStyle={{
        width: `100%`, height: document.body.clientHeight, // window.innerHeight + ((1 - window[`window_zoom`]) * 1000),
        position: `relative`,
        background: underlayBackground
      }}
      dialogStyle={{}}
    >
      <div tabIndex={0} className={`modal bpc flexColumn modal--animated ${modalHasEntered && `has-entered`}`} style={{ textAlign: `center`, /*width: window.innerWidth / 2,*/ ...style }}>
        { enableHeader ? (
          <>
            { underlayClickExits && <IconClose size={16} onClick={deactivateModal} className={`modal-close-icon`} /> }
            <header className="flexColumn modal-header">
              <span className={`type-title type-light`}>{title}</span>
              <span className={`type-small type-secondary ${description !== null && `description`}`}>{description}</span>
            </header>
          </>
        ) : (
          <header id={`modal-h`} className="flexColumn modal-top">
            <span className={`type-title type-light`}>{title}</span>
            <span className={`type-small type-secondary description`}>{description}</span>
          </header>
        )}
        <div className="modal-body">
          <div className={`flexColumn modal-form-container`} style={{ ...style }}>
            { content && React.cloneElement(content, { cancelClick: (content.props.cancelClick) ? content.props.cancelClick : deactivateModal, modalHasEntered }) }
          </div>
        </div>
      </div>
    </AriaModal>
  )
}

ConnectedModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  content: PropTypes.any,
  active: PropTypes.bool,
  enableHeader: PropTypes.bool,
  height: PropTypes.number.isRequired,
  style: PropTypes.object
}

const Modal = connect(
  null,
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    setStateShortcuts: state => dispatch(setStateShortcuts(state))
  })
)(ConnectedModal);

export default Modal;
